import React from "react";
import { Star } from "lucide-react";

/** Read-only star display. `value` can be 0..5 (float allowed for half rendering). */
export function StarsReadOnly({ value = 0, size = 16, className = "" }) {
  const full = Math.round(value);
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} data-testid="stars-readonly">
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          size={size}
          className={n <= full ? "fill-[#C4A482] text-[#C4A482]" : "text-muted-foreground/40"}
          strokeWidth={1.5}
        />
      ))}
    </div>
  );
}

/** Interactive star input. `value` 0..5, `onChange(n)`. */
export function StarsInput({ value = 0, onChange, size = 28 }) {
  const [hover, setHover] = React.useState(0);
  const shown = hover || value;
  return (
    <div className="inline-flex items-center gap-1" data-testid="stars-input">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          onMouseEnter={() => setHover(n)}
          onMouseLeave={() => setHover(0)}
          onClick={() => onChange?.(n)}
          className="rounded-full p-1 transition-transform hover:scale-110"
          aria-label={`${n} étoile${n > 1 ? "s" : ""}`}
          data-testid={`star-${n}`}
        >
          <Star
            size={size}
            className={n <= shown ? "fill-[#C4A482] text-[#C4A482]" : "text-muted-foreground/40"}
            strokeWidth={1.5}
          />
        </button>
      ))}
    </div>
  );
}
